import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import {
  disablePastDate,
  getCurrentTimeZone,
  getFullName,
  getNameChars,
} from "../../../utils/CommonFunctions";
import { httpAdmin, limitToTwoDecimal } from "../../../Apis/commonApis";
import { ShowSwal } from "../../../utils/alertSwal";
import LoadingBtn from "../../../components/Toggle_Button/LoadingBtn";
import { jobTitleOptions, timeValues } from "../../../constants/constants";
import cx from "./newcss.module.css";
import moment from "moment";

const weekDayOptions = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

const ShiftCreationForm = ({ groupArr, getShiftsandtaskNew }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
    control,
  } = useForm();

  const [isRecurring, setIsRecurring] = useState(false);
  const [assignStaffActive, setAssignStaffActive] = useState(false);
  const [openShiftActive, setOpenShiftActive] = useState(false);
  const [shiftDate, setShiftDate] = useState("2025-07-07");
  const [endDate, setEndDate] = useState("2025-07-16");
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("17:00");
  const [selectedDays, setSelectedDays] = useState({
    all: true,
    mon: true,
    tue: true,
    wed: true,
    thu: true,
    fri: true,
    sat: true,
    sun: true,
  });
  const [jobTitleFilter, setJobTitleFilter] = useState("");
  const [criteriaFilter, setCriteriaFilter] = useState("weeklyHoursAssigned");
  const [errorModal, setErrorModal] = useState({
    show: false,
    title: "",
    message: "",
  });
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    title: "",
    message: "",
    onConfirm: null,
  });
  const [staffList, setStaffList] = useState([]);
  const [createdShifts, setCreatedShifts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const startDateValue = watch("applyFrom", "");
    const endDateValue = isRecurring
      ? watch("applyTo", "")
      : watch("applyFrom", "");
    const startTimeValue = watch("startTime", "");
    const endTimeValue = watch("endTime", "");
    const isAllFieldsFilled =
      startDateValue !== "" &&
      endDateValue !== "" &&
      startTimeValue !== "" &&
      endTimeValue !== "";
    if (assignStaffActive && isAllFieldsFilled) {
      getAvailableCareTeam(
        startDateValue,
        endDateValue,
        startTimeValue,
        endTimeValue
      );
    }
  }, [
    jobTitleFilter,
    criteriaFilter,
    watch("startTime", ""),
    watch("endTime", ""),
    watch("applyFrom", ""),
    watch("applyTo", ""),
    assignStaffActive,
  ]);

  const getAvailableCareTeam = async (
    startDateValue,
    endDateValue,
    startTimeValue,
    endTimeValue
  ) => {
    const data = {
      careSiteId: currentCareSiteId,
      priorityBasedOn: criteriaFilter,
      // shiftName: filters?.shiftName,
      jobTitle: jobTitleFilter,
      shiftDates: [
        {
          date: startDateValue,
          startTime: startTimeValue,
          endTime: endTimeValue,
        },
      ],
      startDate: startDateValue,
      endDate: endDateValue,
    };
    const res = await httpAdmin("availableCareMember", "post", data, null);
    if (res.status) {
      let teamdata = [];
      res.data?.forEach((item) => {
        teamdata.push({
          id: item._id,
          name: getFullName(item),
          //  `${item.first_Name} ${item.last_Name}`,
          role: item.role ?? "",
          jobTitle: item.jobTitle ?? "",
          clientGroup: "all",
          image: item.image,
          avatar: getNameChars(item),
          hours: item.totalHours ? limitToTwoDecimal(+item.totalHours) : "0",
          weeklyHoursAssigned: item.totalHours
            ? limitToTwoDecimal(+item.totalHours)
            : 0,
          performance: item.averagePerformance
            ? limitToTwoDecimal(+item.averagePerformance)
            : 0,
          distance: item.distance ? limitToTwoDecimal(+item.distance) : 0,
          selected: false,
        });
      });
      const sortTeamData = sortArrayByKey(teamdata, criteriaFilter);
      setStaffList(sortTeamData);
    } else {
      setStaffList([]);
    }
  };

  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const timeString = `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`;
        options.push(timeString);
      }
    }
    return options;
  };

  const timeOptions = generateTimeOptions();

  const updateEndDateMin = () => {
    if (shiftDate && isRecurring) {
      const startDateObj = new Date(shiftDate);
      startDateObj.setDate(startDateObj.getDate() + 1);
      const nextDay = startDateObj.toISOString().split("T")[0];

      const maxDateObj = new Date(shiftDate);
      maxDateObj.setDate(maxDateObj.getDate() + 30);
      const maxDate = maxDateObj.toISOString().split("T")[0];

      if (endDate && endDate < nextDay) {
        setEndDate(nextDay);
      }
      if (endDate && endDate > maxDate) {
        setEndDate(maxDate);
      }
      if (!endDate) {
        setEndDate(nextDay);
      }
    }
  };

  const toggleRecurring = () => {
    const newRecurring = !isRecurring;
    setIsRecurring(newRecurring);
  };

  const updateEndTimeOptions = (newStartTime) => {
    setStartTime(newStartTime);

    const startIndex = timeOptions.indexOf(newStartTime);
    const filteredOptions = timeOptions.slice(startIndex + 1);

    if (filteredOptions.length < 4) {
      filteredOptions.push(...timeOptions.slice(0, startIndex + 1));
    }

    if (filteredOptions.length > 0) {
      setEndTime(filteredOptions[0]);
    }
  };

  const toggleStaffSection = () => {
    setAssignStaffActive(!assignStaffActive);
    if (!assignStaffActive) {
      setOpenShiftActive(false);
    }
  };

  const toggleOpenShift = () => {
    setOpenShiftActive(!openShiftActive);
    if (!openShiftActive) {
      setAssignStaffActive(false);
    }
  };

  const filterStaffByJobTitle = (jobTitle) => {
    setJobTitleFilter(jobTitle);
  };

  const getCriteriaText = (staff, criteria) => {
    switch (criteria) {
      case "weeklyHoursAssigned":
        return `Shift Hrs: ${staff.hours}`;
      case "distance":
        return `Distance: ${staff.distance} miles`;
      case "performance":
        return `Performance: ${staff.performance}%`;
      default:
        return `Shift Hrs: ${staff.hours}`;
    }
  };

  const sortStaffByCriteria = (staffArray, criteria) => {
    const sorted = [...staffArray];
    switch (criteria) {
      case "Assigned Shift Hours":
        return sorted.sort((a, b) => a.hours - b.hours);
      case "Distance":
        return sorted.sort((a, b) => a.distance - b.distance);
      case "Performance":
        return sorted.sort((a, b) => b.performance - a.performance);
      default:
        return sorted;
    }
  };

  const toggleStaffSelection = (staffId) => {
    const staff = staffList.find((s) => s.id === staffId);

    if (!staff.selected) {
      if (!staff.clientGroup || staff.clientGroup === "Client Group") {
        showErrorModal(
          "Client Group Required",
          `Please select client groups for the following staff members: ${staff.name}`
        );
        return;
      }
    }

    setStaffList((prev) =>
      prev.map((s) => (s.id === staffId ? { ...s, selected: !s.selected } : s))
    );
  };

  const handleClientGroupChange = (staffId, clientGroup) => {
    const staff = staffList.find((s) => s.id === staffId);

    if (staff.selected) {
      showErrorModal(
        "Cannot Change Group",
        `Cannot change client group for ${staff.name} while selected. Please click 'Selected' to deselect first.`
      );
      return;
    }

    setStaffList((prev) =>
      prev.map((s) => (s.id === staffId ? { ...s, clientGroup } : s))
    );
  };

  const showErrorModal = (title, message) => {
    setErrorModal({
      show: true,
      title,
      message,
    });
  };

  const closeErrorModal = () => {
    setErrorModal({
      show: false,
      title: "",
      message: "",
    });
  };

  const showConfirmModal = (title, message, onConfirm) => {
    setConfirmModal({
      show: true,
      title,
      message,
      onConfirm,
    });
  };

  const closeConfirmModal = () => {
    setConfirmModal({
      show: false,
      title: "",
      message: "",
      onConfirm: null,
    });
  };

  const handleConfirm = () => {
    if (confirmModal.onConfirm) {
      confirmModal.onConfirm();
    }
    closeConfirmModal();
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const handleAddShift = async (inputData) => {
    const userTimezone = getCurrentTimeZone();
    const finalData = {
      careHomeId: currentCareSiteId,
      shiftLimit: 1,
      applyFrom: inputData.applyFrom,
      applyTo: isRecurring ? inputData.applyTo : inputData.applyFrom,
      shiftDetails: [
        {
          shiftName: inputData.shiftName,
          shiftBreak: inputData.shiftBreak,
          startTime: inputData.startTime,
          endTime: inputData.endTime,
        },
      ],
      timeZone: userTimezone,
      assignedCareTeam: [],
      weekDaysArray: [],
    };
    if (isRecurring) {
      const individualDaysSelected = weekDayOptions.filter(
        (day) => selectedDays[day]
      );

      if (individualDaysSelected.length === 0) {
        showErrorModal(
          "Days Selection Required",
          "Please select at least one day for the recurring shift."
        );
        return;
      }
      finalData.weekDaysArray = individualDaysSelected;
    }
    const filterSelectedStaff = staffList.filter((sItem) => sItem.selected);
    if (assignStaffActive) {
      if (filterSelectedStaff?.length > 0) {
        finalData.recurringShiftType = "assigned";
        finalData.assignedCareTeam = filterSelectedStaff.map((sItem) => {
          return {
            innerShiftType: "new",
            careTeamId: sItem.id,
            clientId: sItem.clientGroup,
            all: sItem.clientGroup === "all" ? true : false,
            timing: "within time",
            startTime: "",
            endTime: "",
          };
        });
      } else {
        showErrorModal(
          "Missing Information",
          "Please select atleast one staff to proceed"
        );
        return;
      }
    }
    if (openShiftActive) {
      finalData.recurringShiftType = "open";
      finalData.openShiftStart = inputData.startTime;
      finalData.openShiftEnd = inputData.endTime;
      finalData.openShiftZone = inputData.openShiftZone;
    }
    setLoading(true);
    const res = await httpAdmin(`createShiftConfig`, "post", finalData, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      const assignedStaffNames = filterSelectedStaff.map((sItem) => {
        const selectedGroup =
          sItem.clientGroup === "all"
            ? "All Clients"
            : groupArr.find((gItem) => gItem.groupId === sItem.clientGroup)
                ?.groupName;
        return `${sItem.name} (${selectedGroup})`;
      });

      setCreatedShifts((prev) => [
        ...prev,
        {
          id: res.mainshiftId ?? res.shiftId,
          mainshiftId: res.mainshiftId,
          shiftId: res.shiftId,
          name: inputData.shiftName,
          type: isRecurring ? "recurring" : "single",
          dateRange: isRecurring
            ? `${inputData.applyFrom}  - ${
                inputData.applyTo
              } (${finalData.weekDaysArray
                .map((item) => item.toUpperCase())
                .join(", ")})`
            : inputData.applyFrom,
          time: `${inputData.startTime} - ${inputData.endTime}`,
          break: `${inputData.shiftBreak} min break`,
          staff: openShiftActive
            ? "Open Shift"
            : assignedStaffNames.length > 0
            ? assignedStaffNames.join(", ")
            : "Unassigned",
        },
      ]);
      setOpenShiftActive(false);
      setAssignStaffActive(false);
      setIsRecurring(false);
      setStaffList([]);
      setSelectedDays({
        all: true,
        mon: true,
        tue: true,
        wed: true,
        thu: true,
        fri: true,
        sat: true,
        sun: true,
      });
      reset();
    }
    setLoading(false);
  };

  const removeShift = (shift) => {
    console.log(shift, "sssssssssssss");
    showConfirmModal(
      "Remove Shift",
      `Are you sure you want to remove "${shift?.name}" shift?`,
      () => {
        deleteShift(shift);
      }
    );
  };

  const deleteShift = async (shift) => {
    let idToRemove = {};
    if (shift?.mainshiftId) {
      idToRemove.mainshiftId = shift?.mainshiftId;
    } else {
      idToRemove.shiftId = shift?.shiftId;
    }
    const removeShiftId = shift?.mainshiftId ?? shift?.shiftId;
    const res = await httpAdmin(`deleteshift`, "post", idToRemove, null);
    ShowSwal(res.status, res.message);
    if (res.status) {
      setCreatedShifts((prev) => prev.filter((s) => s.id !== removeShiftId));
    }
  };

  const handleDayToggle = (day) => {
    const newDays = { ...selectedDays, [day]: !selectedDays[day] };
    const allSelected = weekDayOptions.every((d) => newDays[d]);
    newDays.all = allSelected;
    setSelectedDays(newDays);
  };

  const handleAllDaysToggle = () => {
    const newAllState = !selectedDays.all;
    setSelectedDays({
      all: newAllState,
      mon: newAllState,
      tue: newAllState,
      wed: newAllState,
      thu: newAllState,
      fri: newAllState,
      sat: newAllState,
      sun: newAllState,
    });
  };

  useEffect(() => {
    updateEndDateMin();
  }, [shiftDate, isRecurring]);

  useEffect(() => {
    updateEndTimeOptions(startTime);
  }, []);

  function getCurrentDateTime(type) {
    const currentTime = moment().tz(getCurrentTimeZone()).format("HH:mm");
    const currentDate = moment().tz(getCurrentTimeZone()).format("YYYY-MM-DD");
    if (type === "date") {
      return currentDate;
    }
    return currentTime;
  }

  return (
    <div>
      <div
        style={{
          margin: "0 auto",
          padding: "0px",
        }}
      >
        <form onSubmit={handleSubmit(handleAddShift)}>
          <div>
            <div
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#374151",
                marginBottom: "8px",
              }}
            >
              Shift Details
            </div>

            <div
              style={{
                display: "flex",
                gap: "16px",
                marginBottom: "16px",
                alignItems: "end",
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    onClick={toggleRecurring}
                    style={{
                      position: "relative",
                      width: "44px",
                      height: "24px",
                      background: isRecurring ? "#8b5cf6" : "#d1d5db",
                      borderRadius: "12px",
                      cursor: "pointer",
                      transition: "background 0.2s",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        width: "20px",
                        height: "20px",
                        background: "white",
                        borderRadius: "50%",
                        top: "2px",
                        left: "2px",
                        transform: isRecurring
                          ? "translateX(20px)"
                          : "translateX(0)",
                        transition: "transform 0.2s",
                      }}
                    />
                  </div>
                  <span style={{ fontSize: "16px", color: "#000" }}>
                    Recurring Shift
                  </span>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "16px",
                marginBottom: "16px",
                flexDirection: "column",
              }}
            >
              <div style={{ display: "flex", flex: 1, gap: "16px" }}>
                <div style={{ flex: 1 }}>
                  <label className={`${cx.inputLabels}`}>{"Start Date"}</label>
                  <input
                    className={`${cx.inputNewField}`}
                    type="date"
                    min={disablePastDate()}
                    name="applyFrom"
                    {...register("applyFrom", {
                      required: true,
                    })}
                  />
                  {errors?.applyFrom?.type === "required" ? (
                    <p className="error_style">This field is required</p>
                  ) : (
                    <p className="error_style">&nbsp;</p>
                  )}
                </div>

                {isRecurring ? (
                  <div style={{ flex: 1 }}>
                    <label className={`${cx.inputLabels}`}>{"End Date"}</label>
                    <input
                      type="date"
                      min={(() => {
                        const startDate = watch("applyFrom");
                        if (startDate) {
                          const date = new Date(startDate);
                          date.setDate(date.getDate() + 1);
                          return date.toISOString().split("T")[0];
                        }
                        return disablePastDate();
                      })()}
                      className={`${cx.inputNewField}`}
                      name="applyTo"
                      {...register("applyTo", {
                        required: isRecurring,
                      })}
                    />
                    {errors?.applyTo?.type === "required" ? (
                      <p className="error_style">This field is required</p>
                    ) : (
                      <p className="error_style">&nbsp;</p>
                    )}
                  </div>
                ) : (
                  <div style={{ flex: 1 }}></div>
                )}
              </div>

              {isRecurring && (
                <div style={{ flex: 1 }} className="mb-3">
                  <label className={`${cx.inputLabels}`}>Select Days:</label>
                  <div
                    style={{
                      display: "flex",
                      gap: "12px",
                      flexWrap: "wrap",
                      color: "374151",
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        fontWeight: "600",
                        color: "#8b5cf6",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedDays.all}
                        onChange={handleAllDaysToggle}
                        style={{ width: "14px", height: "14px" }}
                      />
                      ALL
                    </label>
                    {weekDayOptions.map((dayKey) => {
                      return (
                        <label
                          key={dayKey}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "12px",
                            fontWeight: "500",
                            color: "374151",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedDays[dayKey]}
                            onChange={() => handleDayToggle(dayKey)}
                            style={{ width: "14px", height: "14px" }}
                          />
                          {dayKey.toUpperCase()}
                        </label>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                gap: "16px",
                marginBottom: "8px",
                alignItems: "end",
              }}
            >
              <div style={{ flex: 1 }}>
                <label className={`${cx.inputLabels}`}>Shift Name</label>
                <input
                  type="text"
                  placeholder="Enter shift name"
                  className={`${cx.inputNewField}`}
                  name="shiftName"
                  {...register("shiftName", {
                    required: true,
                  })}
                />
                {errors?.shiftName?.type === "required" ? (
                  <p className="error_style">This field is required</p>
                ) : (
                  <p className="error_style">&nbsp;</p>
                )}
              </div>
              <div style={{ flex: 1 }}>
                <label className={`${cx.inputLabels}`}>Break Time (mins)</label>
                <input
                  type="number"
                  placeholder=""
                  min="0"
                  className={`${cx.inputNewField}`}
                  name="shiftBreak"
                  {...register("shiftBreak", {
                    required: false,
                  })}
                />
                {<p className="error_style">&nbsp;</p>}
              </div>
              <div style={{ flex: 0.5 }}>
                <label className={`${cx.inputLabels}`}>Start Time</label>
                <select
                  name="startTime"
                  {...register("startTime", {
                    required: true,
                  })}
                  className={`${cx.inputNewField}`}
                >
                  <option value="">--Select--</option>
                  {timeValues
                    .filter((item) =>
                      watch(`applyFrom`, "") <= getCurrentDateTime("date")
                        ? item.value > getCurrentDateTime("time")
                        : true
                    )
                    .map((vals) => (
                      <option key={vals.value} value={vals.value}>
                        {vals.label}
                      </option>
                    ))}
                </select>
                {errors?.startTime?.type === "required" ? (
                  <p className="error_style">This field is required</p>
                ) : (
                  <p className="error_style">&nbsp;</p>
                )}
              </div>
              <div style={{ flex: 0.5 }}>
                <label className={`${cx.inputLabels}`}>End Time</label>
                <select
                  className={`${cx.inputNewField}`}
                  name="endTime"
                  {...register("endTime", {
                    required: true,
                  })}
                >
                  <option value="">--Select--</option>
                  {timeValues
                    .filter((elem) => elem.value > watch(`startTime`, ""))
                    .map((vals) => (
                      <option key={vals.value} value={vals.value}>
                        {vals.label}
                      </option>
                    ))}
                </select>
                {errors?.endTime?.type === "required" ? (
                  <p className="error_style">This field is required</p>
                ) : (
                  <p className="error_style">&nbsp;</p>
                )}
              </div>
            </div>
          </div>

          <div style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "12px",
              }}
            >
              <div
                onClick={toggleStaffSection}
                style={{
                  position: "relative",
                  width: "44px",
                  height: "24px",
                  background: assignStaffActive ? "#8b5cf6" : "#d1d5db",
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    width: "20px",
                    height: "20px",
                    background: "white",
                    borderRadius: "50%",
                    top: "2px",
                    left: "2px",
                    transform: assignStaffActive
                      ? "translateX(20px)"
                      : "translateX(0)",
                    transition: "transform 0.2s",
                  }}
                />
              </div>
              <span style={{ color: "#000", fontSize: "14px" }}>
                Assign Staff (Optional)
              </span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "12px",
              }}
            >
              <div
                onClick={toggleOpenShift}
                style={{
                  position: "relative",
                  width: "44px",
                  height: "24px",
                  background: openShiftActive ? "#8b5cf6" : "#d1d5db",
                  borderRadius: "12px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    width: "20px",
                    height: "20px",
                    background: "white",
                    borderRadius: "50%",
                    top: "2px",
                    left: "2px",
                    transform: openShiftActive
                      ? "translateX(20px)"
                      : "translateX(0)",
                    transition: "transform 0.2s",
                  }}
                />
              </div>
              <span style={{ color: "#000", fontSize: "14px" }}>
                Open Shift
              </span>
            </div>

            {openShiftActive && (
              <div
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "16px",
                  marginBottom: "16px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "6px",
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#374151",
                    }}
                  >
                    Client Group for Open Shift
                  </label>
                  <select
                    className={`${cx.inputNewField}`}
                    name="openShiftZone"
                    {...register("openShiftZone", {
                      required: openShiftActive,
                    })}
                  >
                    <option value="all">All Client</option>
                    {groupArr?.map((elem) => {
                      return (
                        <option key={elem.groupId} value={elem.groupId}>
                          {elem.groupName}
                        </option>
                      );
                    })}
                  </select>
                  {errors?.openShiftZone?.type === "required" ? (
                    <p className="error_style">This field is required</p>
                  ) : (
                    <p className="error_style">&nbsp;</p>
                  )}
                </div>
              </div>
            )}

            {assignStaffActive && (
              <div
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: "8px",
                  padding: "16px",
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    marginBottom: "16px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <select
                      value={jobTitleFilter}
                      onChange={(e) => filterStaffByJobTitle(e.target.value)}
                      className={`${cx.inputNewField}`}
                    >
                      <option value="">Job Title</option>
                      <option value="all">All</option>
                      {jobTitleOptions.map((item) => {
                        return (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <select
                      value={criteriaFilter}
                      onChange={(e) => setCriteriaFilter(e.target.value)}
                      className={`${cx.inputNewField}`}
                    >
                      <option value="weeklyHoursAssigned">
                        Assigned Shift Hours
                      </option>
                      <option value="distance">Distance</option>
                      <option value="performance">Performance</option>
                    </select>
                  </div>
                </div>

                <div
                  style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    padding: "12px",
                  }}
                >
                  {staffList.length > 0 ? (
                    staffList.map((staff) => (
                      <div
                        key={staff.id}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "12px 16px",
                          marginBottom: "10px",
                          borderRadius: "8px",
                          transition: "background 0.2s",
                          backgroundColor: "#f9fafb",
                          border: "1px solid #e5e7eb",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              background: "#f59e0b",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "white",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            {/* {staff.avatar} */}
                            {staff.image ? (
                              <img
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "cover",
                                  borderRadius: "25px",
                                }}
                                src={staff.image}
                                alt="img"
                              />
                            ) : (
                              staff.avatar
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: "500",
                                color: "#1f2937",
                              }}
                            >
                              {staff.name}
                            </div>
                            <div
                              style={{
                                fontSize: "14px",
                                color: "#6b7280",
                              }}
                            >
                              {staff.jobTitle}
                            </div>
                            <div
                              style={{
                                fontSize: "13px",
                                color: "#059669",
                                fontWeight: "500",
                                marginTop: "3px",
                              }}
                            >
                              {getCriteriaText(staff, criteriaFilter)}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                          }}
                        >
                          <select
                            value={staff.clientGroup}
                            onChange={(e) =>
                              handleClientGroupChange(staff.id, e.target.value)
                            }
                            disabled={staff.selected}
                            style={{
                              width: "250px",
                              marginRight: "8px",
                              fontSize: "14px",
                              padding: "6px 10px",
                              border: "1px solid #d1d5db",
                              borderRadius: "6px",
                              backgroundColor: staff.selected
                                ? "#f3f4f6"
                                : "white",
                              color: staff.selected ? "#6b7280" : "inherit",
                            }}
                          >
                            <option value="all">All Client</option>
                            {groupArr?.map((elem) => {
                              return (
                                <option key={elem.groupId} value={elem.groupId}>
                                  {elem.groupName}
                                </option>
                              );
                            })}
                          </select>
                          <button
                            onClick={() => toggleStaffSelection(staff.id)}
                            type="button"
                            style={{
                              padding: "6px 12px",
                              fontSize: "14px",
                              borderRadius: "6px",
                              border: "1px solid #8b5cf6",
                              background: staff.selected ? "#8b5cf6" : "white",
                              color: staff.selected ? "white" : "#8b5cf6",
                              cursor: "pointer",
                            }}
                          >
                            {staff.selected ? "Selected" : "Select"}
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div>
                      No Careteam available for selected time and filters.
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div style={{ marginBottom: "24px" }}>
            <div
              style={{
                display: "flex",
                gap: "16px",
                marginBottom: "16px",
                alignItems: "end",
              }}
            >
              <button type="submit" className={`${cx.inputBtns}`}>
                {loading ? (
                  <LoadingBtn style={{ width: "16px", height: "16px" }} />
                ) : (
                  "Add Shift"
                )}
              </button>
            </div>
          </div>
        </form>

        <div style={{ marginBottom: "24px" }}>
          <div
            style={{
              fontSize: "16px",
              fontWeight: "600",
              color: "#374151",
              marginBottom: "16px",
            }}
          >
            Created Shifts
          </div>
          <div
            style={{
              background: "#f9fafb",
              borderRadius: "10px",
              padding: "20px",
              marginBottom: "16px",
            }}
          >
            {createdShifts.length > 0 ? (
              createdShifts.map((shift) => (
                <div
                  key={shift.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    background: "white",
                    padding: "16px",
                    borderRadius: "8px",
                    marginBottom: "12px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "3px",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        color: "#1f2937",
                        fontSize: "16px",
                      }}
                    >
                      {shift.name}
                      <span
                        style={{
                          display: "inline-block",
                          padding: "2px 8px",
                          borderRadius: "12px",
                          fontSize: "10px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                          marginLeft: "8px",
                          background:
                            shift.type === "recurring" ? "#dbeafe" : "#fef3c7",
                          color:
                            shift.type === "recurring" ? "#1e40af" : "#92400e",
                        }}
                      >
                        {shift.type}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#6b7280",
                      }}
                    >
                      {shift.dateRange} • {shift.time} • {shift.break}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#059669",
                      }}
                    >
                      Staff: {shift.staff}
                    </div>
                  </div>
                  <button
                    onClick={() => removeShift(shift)}
                    className={`${cx.inputRemoveBtns}`}
                  >
                    Remove
                  </button>
                </div>
              ))
            ) : (
              <div>Not Available.</div>
            )}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
            justifyContent: "flex-end",
            marginTop: "24px",
          }}
        >
          <button
            className={`${cx.inputCancelBtns}`}
            onClick={() => getShiftsandtaskNew("createOrEdit")}
          >
            Cancel
          </button>
          <button
            className={`${cx.inputBtns}`}
            onClick={() => getShiftsandtaskNew("createOrEdit")}
          >
            Done
          </button>
        </div>
      </div>

      {/* Error Modal */}
      {errorModal.show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              width: "400px",
              maxWidth: "90%",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
            }}
          >
            <div
              style={{
                background: "#8b5cf6",
                color: "white",
                padding: "16px 20px",
                borderRadius: "12px 12px 0 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Alert
              </div>
              <button
                onClick={closeErrorModal}
                style={{
                  background: "none",
                  border: "none",
                  color: "white",
                  fontSize: "24px",
                  cursor: "pointer",
                  padding: 0,
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ×
              </button>
            </div>
            <div
              style={{
                padding: "30px 20px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "60px",
                  height: "60px",
                  background: "#fbbf24",
                  borderRadius: "50%",
                  margin: "0 auto 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "30px",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                !
              </div>
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#7c2d12",
                  marginBottom: "15px",
                }}
              >
                {errorModal.title}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                  lineHeight: 1.5,
                  marginBottom: "25px",
                }}
              >
                {errorModal.message}
              </div>
              <button
                onClick={closeErrorModal}
                style={{
                  background: "#8b5cf6",
                  color: "white",
                  border: "none",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "600",
                  cursor: "pointer",
                  minWidth: "80px",
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {confirmModal.show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "12px",
              width: "400px",
              maxWidth: "90%",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
            }}
          >
            <div
              style={{
                background: "#8b5cf6",
                color: "white",
                padding: "16px 20px",
                borderRadius: "12px 12px 0 0",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                Alert
              </div>
              <button
                onClick={closeConfirmModal}
                style={{
                  background: "none",
                  border: "none",
                  color: "white",
                  fontSize: "24px",
                  cursor: "pointer",
                  padding: 0,
                  width: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                ×
              </button>
            </div>
            <div
              style={{
                padding: "30px 20px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: "#7c2d12",
                  marginBottom: "15px",
                }}
              >
                {confirmModal.title}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  color: "#6b7280",
                  lineHeight: 1.5,
                  marginBottom: "25px",
                }}
              >
                {confirmModal.message}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={closeConfirmModal}
                  style={{
                    background: "#f3f4f6",
                    color: "#374151",
                    border: "1px solid #d1d5db",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "80px",
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleConfirm}
                  style={{
                    background: "#8b5cf6",
                    color: "white",
                    border: "none",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    minWidth: "80px",
                  }}
                >
                  Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShiftCreationForm;

const sortArrayByKey = (arr, key) => {
  return [...arr].sort((a, b) => {
    const valA = Number(a[key]);
    const valB = Number(b[key]);
    if (key === "performance") {
      return valB - valA;
    }
    return valA - valB;
  });
};
